import React from 'react';
import useAuth from '../hooks/useAuth';
import { ROLES } from '../utils/constants';
import VerificationDashboard from '../components/verification/VerificationDashboard';
import './VerificationPage.css';

const VerificationPage = () => {
  const { userRole } = useAuth();

  // If user is a verifier, show the dashboard.
  // If user is an admin/owner, they also see the dashboard but in a wider context (simulated here)
  const isVerifier = userRole === ROLES.VERIFIER;

  return (
    <div className="verification-page">
      {!isVerifier && (
        <div className="admin-notice">
          <strong>Admin View:</strong> You are viewing the verification queue with managerial oversight capabilities.
        </div>
      )}
      
      <VerificationDashboard />
    </div>
  );
};

export default VerificationPage;
